import formErrorPresentertemplate from './formErrorPresenter.tpl.html';

export class FormErrorPresenter {
  constructor($scope, $ngRedux, actionsFactory, $translate) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
    });
  }

  $onInit() {
    this.buildErrorMessage();
  }

  $postLink() {
    this.form.$$element.on('change', () => {
      this.buildErrorMessage();
    });
  }


  buildErrorMessage() {
    // only required fields handling
    this.fields = '';
    this.descr_translatekey = 'ERROR_FIELD_MANDATORY';
    if (this.form.$error) {
      this.form.$error.required.forEach((field, index) => {
        this.fields += `${field.$$attr.humanReadable}`;
        if (this.form.$error.required.length > (index + 1)) {
          this.fields += ',';
        }
        this.fields += ' ';
      });
    }
    this.message = `${this.fields}- ${this.descr}`;
  }
}

FormErrorPresenter.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
];

export const formErrorPresenter = {
  template: formErrorPresentertemplate,
  controller: FormErrorPresenter,
  bindings: {
    form: '<',
  },
};
